import * as React from 'react';
import * as S from './styles';
import { IProps } from './types';
import WidgetCall from '../WidgetCall';

const DesktopPreview: React.FC<IProps> = (props) => {

    const titles: string[] = [props.widgetCalls.length>1?"Aggregate reviews":"","Reviews by Platform","Featured reviews","Leave a Review","Reviews List"];

    const renderWidgetCall = (widgetCall: string|undefined, index: number) => {
        return (
            <S.WidgetContainer bgColor={(props.backgroundColors.length > index) ? props.backgroundColors[index] : "#fff"} selectedTab={props.selectedTab}>
                <S.TitleContainer>
                    {
                        titles[index]
                    }
                </S.TitleContainer>
                <WidgetCall widgetCall={widgetCall} widgetIndex={index} />
            </S.WidgetContainer>
        );
    }

    return (
        <S.MainContainer>
            <S.GlobalContainer selectedTab={props.selectedTab}>
            {
                props.widgetCalls.map((widgetCall: string|undefined, index: number) => {
                    if (widgetCall!=undefined)
                        return renderWidgetCall(widgetCall, index);
                })
            }
            </S.GlobalContainer>
        </S.MainContainer>
    )
}

export default DesktopPreview;
